var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 8C4.5 6.067 6.067 4.5 8 4.5C9.933 4.5 11.5 6.067 11.5 8C11.5 9.933 9.933 11.5 8 11.5C6.067 11.5 4.5 9.933 4.5 8ZM8 5.5C6.6193 5.5 5.5 6.6193 5.5 8C5.5 9.3807 6.6193 10.5 8 10.5C9.3807 10.5 10.5 9.3807 10.5 8C10.5 6.6193 9.3807 5.5 8 5.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.51335 11.7497C-1.36846 6.7508 2.23306 0.5 7.99966 0.5C13.7663 0.5 17.3678 6.7508 14.486 11.7497L11.5528 16.8379C12.6904 17.4954 13.4997 18.5069 13.4997 19.7273C13.4997 20.8545 12.802 21.8099 11.8091 22.4598C10.8118 23.1126 9.46346 23.5 7.99966 23.5C6.53586 23.5 5.18756 23.1126 4.19026 22.4598C3.19736 21.8099 2.49966 20.8545 2.49966 19.7273C2.49966 18.5069 3.30896 17.4954 4.44656 16.8379L1.51335 11.7497ZM7.99966 1.5C3.00516 1.5 -0.11908 6.9158 2.37966 11.2503L7.56646 20.2475C7.75886 20.5812 8.24046 20.5812 8.43286 20.2475L13.6197 11.2503C16.1184 6.9158 12.9942 1.5 7.99966 1.5ZM4.94556 17.7033C4.00216 18.2456 3.49966 18.991 3.49966 19.7273C3.49966 20.4075 3.92126 21.0885 4.73796 21.6231C5.55026 22.1548 6.70206 22.5 7.99966 22.5C9.29726 22.5 10.4491 22.1548 11.2614 21.6231C12.0781 21.0885 12.4997 20.4075 12.4997 19.7273C12.4997 18.991 11.9972 18.2456 11.0538 17.7033L9.29916 20.7469C8.72206 21.748 7.27726 21.748 6.70016 20.7469L4.94556 17.7033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.33bf89fd52558af3386785cd51a4e368.svg";
export { ForwardRef as ReactComponent };